import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-funktionsbereich-checkliste-pruefbericht-xml';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungFunktionsbereichChecklistePruefberichtXmlEffects {

    VeranstaltungFunktionsbereichChecklistePruefberichtXml$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_FUNKTIONSBEREICH_CHECKLISTE_PRUEFBERICHT_XML),
        mergeMap((x: ac.GetVeranstaltungFunktionsbereichChecklistePruefberichtXmlAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungFunktionsbereichChecklistePruefberichtXml(x.veranstaltung_id, x.funktionsbereich_id, x.checkliste_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungFunktionsbereichChecklistePruefberichtXmlErfolgreichAction(x.veranstaltung_id, x.funktionsbereich_id, x.checkliste_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungFunktionsbereichChecklistePruefberichtXmlFehlerAction(error, x.veranstaltung_id, x.funktionsbereich_id, x.checkliste_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungenQueryService);
        }
        return this.service;
    }
}
